import { useState } from 'react';
import { deleteData } from '../api/apiService';

export const useDelete = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const deleteRequest = async (endpoint, requestData) => {
		setLoading(true);
		try {
			const { data } = await deleteData(endpoint, requestData);
			setData(data);
		} catch (error) {
			setError(error);
		} finally {
			setLoading(false);
		}
	};

	return { data, loading, error, deleteRequest };
};
